import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://ztoagnujhfsfemsuudgl.supabase.co"
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp0b2FnbnVqaGZzZmVtc3V1ZGdsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQyNDgyNzYsImV4cCI6MjA3OTgyNDI3Nn0.ByqpgW6Uq5Stx2Otmnw9cVyEBDo-9nIV_PyYubY2VIM"

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase environment variables')
}

import type { Database } from '../types/supabase'

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)
